export const InstallExt = {
  extends: 'ModalWindow',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: 'shadow',
  ModalHeader: null,
  IconButton: null,
  Flex: {
    align: 'start',
    gap: 'Z2',
    whiteSpace: 'nowrap',
    Img: {
      src: 'chrome-ext-icon.png',
      width: 'C',
      margin: '-W - - -'
    },
    Hgroup: {
      H: {
        tag: 'strong',
        text: '{{ learn.install.extTitle | polyglot }}'
      },
      P: {
        text: '{{ learn.install.extDescr | polyglot }}'
      },
      gap: 'X'
    }
  },
  Flex_Buttons: {
    align: 'start',
    gap: 'Z',
    childExtends: 'Button',
    margin: '- - - -X',
    Install: {
      extends: ['Link', 'Button'],
      href: '/docs/chrome-extension',
      target: '_blank',
      text: '{{ learn.install.install | polyglot }}',
      theme: 'primary',
      icon: 'arrow up right',
      gap: 'X2',
      minHeight: 'controlH',
      padding: '0 A',
      round: 'radiusPill',
      fontSize: 'Z2',
      fontWeight: '700',
      Icon: {
        order: 2
      },
      onClick: () => {}
    },
    Cancel: {
      text: '{{ common.action.cancel | polyglot }}',
      // `line` border removed (border-habit sweep, design-direction.md §8)
      // — `theme: 'tertiary'` ("the quiet/text control theme", DESIGN_LANGUAGE
      // §2.4) already supplies a complete, transparent-at-rest state language
      // (rest/hover/active); the manual outline on top was the outlined-
      // button habit, working against the theme's own quiet intent.
      theme: 'tertiary',
      gap: 'X2',
      minHeight: 'controlH',
      padding: '0 A',
      round: 'radiusPill',
      fontSize: 'Z2',
      onClick: (ev, el) => el.closeModal()
    }
  }
}
